/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core';
import {JobTaskFileNameChooserProps} from './JobTaskFileNameChooser';
import JobTaskLMUConfigFields from './JobTaskLMUConfigFields';
import JobTaskLMUConfigSearch from './JobTaskLMUConfigSearch';
import {LMUConfigSearchField} from './JobTaskLMUConfigUtils';

// defines the wrapper component style definitions ...
const useStyles = makeStyles(() => ({
  container : {
    minWidth : '200px',
    position : 'relative'
  }
}));

/**
 * Defines the `JobTaskLMUConfigChooser` prop type definitions. We simply
 * reference the `JobTaskFileNameChooserProps` and define prop definitions
 * for the component for improved semantics.
 */
export type JobTaskLMUConfigChooserProps = JobTaskFileNameChooserProps

/**
 * @internal
 *
 * The `JobTaskLMUConfigChooser` component provides the feature for performing
 * Custom LMU Config Searches for Files by 'version', or 'name'. By default,
 * the `LMUConfigSearchField` is set to `version`.
 *
 * @see {@link JobTaskLMUConfigFields}
 * @see {@link JobTaskLMUConfigSearch}
 *
 * @param onChange function prop which is invoked when a `DeviceFile` is selected.
 */
const JobTaskLMUConfigChooser = (props: JobTaskLMUConfigChooserProps) => {
  const classes = useStyles();
  const [field, setField] = useState<LMUConfigSearchField>(LMUConfigSearchField.version);

  return (
    <div className={classes.container}>
      <JobTaskLMUConfigFields defaultField={field} onChange={setField} />
      <JobTaskLMUConfigSearch field={field} {...props}/>
    </div>
  );
};

export default JobTaskLMUConfigChooser;
